var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBusinessUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12205_3918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3968 15.667V16C20.3968 17.105 19.5658 18 18.5398 18H17.9208C16.8948 18 16.0638 17.105 16.0638 16C16.0638 17.105 15.2328 18 14.2068 18H13.5878C12.6588 18 11.8888 17.265 11.7518 16.306C11.7307 16.1047 11.7635 15.9014 11.8468 15.717L12.2018 14.856C12.4283 14.3068 12.8128 13.8373 13.3064 13.5069C13.8001 13.1765 14.3808 13.0001 14.9748 13H21.4838C22.0778 13.0001 22.6585 13.1765 23.1521 13.5069C23.6458 13.8373 24.0303 14.3068 24.2568 14.856L24.6118 15.717C24.6888 15.903 24.7358 16.107 24.7068 16.306C24.5698 17.265 23.8008 18 22.8708 18H22.2518C21.2258 18 20.3948 17.105 20.3948 16M14.7148 6C14.7148 2.691 12.0238 0 8.7148 0C5.4058 0 2.7168 2.691 2.7168 6C2.7168 9.309 5.4078 12 8.7168 12C12.0258 12 14.7168 9.309 14.7168 6H14.7148ZM22.8708 20H22.2518C21.5788 20 20.9458 19.82 20.3958 19.505C19.8306 19.8292 19.1904 19.9999 18.5388 20H17.9198C17.2468 20 16.6138 19.82 16.0628 19.505C15.498 19.8293 14.8581 20 14.2068 20H13.5878C13.2928 20 13.0088 19.953 12.7308 19.887V21C12.7308 22.654 14.0768 24 15.7308 24H20.7308C22.3848 24 23.7308 22.654 23.7308 21V19.887C23.4506 19.9585 23.1629 19.9964 22.8738 20H22.8708ZM10.7288 21V18.661C10.2153 18.0774 9.88214 17.3572 9.7698 16.588C9.6948 16.054 9.7698 15.506 9.9948 14.959L10.3228 14.162C9.7936 14.0541 9.25488 13.9998 8.7148 14C4.3058 14 0.716797 17.589 0.716797 22V23C0.716797 23.2652 0.822154 23.5196 1.00969 23.7071C1.19723 23.8946 1.45158 24 1.7168 24H11.7558C11.094 23.1396 10.7325 22.0855 10.7288 21Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12205_3918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.716797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBusinessUser);
export default __webpack_public_path__ + "static/media/addBusinessUser.9e09cc9a14ca43669d61dc9e165efbf0.svg";
export { ForwardRef as ReactComponent };